module.exports = __webpack_public_path__ + "img/w55b.6f104f14.jpg";